import { getUserSettings } from '@surfline/web-common';

const getFeedGeotarget = (state) => {
  let geotarget = 'US';
  if (state?.flags?.identity?.isoCountryCode) {
    const {
      flags: {
        identity: { isoCountryCode },
      },
    } = state;
    geotarget = isoCountryCode;
  }
  const userSettings = getUserSettings(state);
  const localized = userSettings?.feed?.localized;
  if (localized) {
    geotarget = localized !== 'LOCALIZED' ? localized : geotarget;
  }
  return geotarget;
};

export default getFeedGeotarget;
